import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PaymentsApi } from '../../services/paymentsServices';

export const fetchPayments = createAsyncThunk(
  'payments/fetchPayments',
  async () => {
    const data = await PaymentsApi.fetchListOfPaymentsForTheAdmin();
    return data; 
  }
);

export const fetchPaymentDetails = createAsyncThunk(
  'payments/fetchPaymentDetails',
  async (transactionId, { rejectWithValue }) => {
    try {
      const data = await PaymentsApi.fetchSinglePaymentTransactionDetail(transactionId);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const searchAndFilterPayments = createAsyncThunk(
  'payments/searchAndFilterPayments',
  async ({ search_term, ...filters }, { rejectWithValue }) => {
    try {
      const data = await PaymentsApi.searchAndFilterPaymentAdminSide(search_term, filters);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const paymentsSlice = createSlice({
  name: 'payments',
  initialState: {
    loading: false,
    error: null,
    data: [],
    currentPayment: null,
    isSearching: false,
    currentFilters: null,
    currentSearchTerm: ''
  },
  reducers: {
    resetPaymentsFilters: (state) => {
      state.isSearching = false;
      state.currentFilters = null;
      state.currentSearchTerm = '';
    },
    clearCurrentPayment: (state) => {
      state.currentPayment = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch Payments
      .addCase(fetchPayments.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.isSearching = false;
        state.currentFilters = null;
        state.currentSearchTerm = '';
      })
      .addCase(fetchPayments.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchPayments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      
      // Fetch Single Payment
      .addCase(fetchPaymentDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPaymentDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.currentPayment = action.payload;
      })
      .addCase(fetchPaymentDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      
      // Search and Filter Payments
      .addCase(searchAndFilterPayments.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        state.isSearching = true;
        state.currentSearchTerm = action.meta.arg.search_term || '';
      })
      .addCase(searchAndFilterPayments.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.isSearching = false;
        const { search_term, ...filters } = action.meta.arg;
        state.currentFilters = filters;
      })
      .addCase(searchAndFilterPayments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.isSearching = false;
      });
  },
});

export const { resetPaymentsFilters, clearCurrentPayment } = paymentsSlice.actions;
export default paymentsSlice.reducer;